<template>
  <v-dialog v-model="showModal" persistent max-width="500">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          <v-icon>info</v-icon>
            Sure to send Reminder?
          </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="$emit('close-modal-send-reminder')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <span class="subheading"> Round: <strong> {{round.name}}</strong> </span><br>
        <span class="subheading">Once confirmed this action cannot be reversed.</span>
        
        <v-list prepend-icon="directions_run">
          <v-list-tile v-if="round.last_reminder">
            <v-list-tile-title>
              <v-icon>date_range</v-icon>
              Last reminder: <strong> {{round.last_reminder}} </strong>
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>
              <v-icon>perm_contact_calendar</v-icon>
              Total reminders to be sent: <strong>{{ totalSend }}</strong>
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>
              <v-icon>unsubscribe</v-icon>
              will not be sent: <strong> {{ totalNotSend }} </strong> 
            </v-list-tile-title>
          </v-list-tile>
          <p> <strong>Note:</strong> There is a validation so that a reminder is not sent to contacts that have not been sent more than 24 hrs since the last sent.</p>
          
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat @click="$emit('close-modal-send-reminder')">No</v-btn>
        <v-btn color="green darken-1" flat @click="$emit('send-reminder'); $emit('close-modal-send-reminder')">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    round: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      totalSend: 0,
      totalNotSend: 0
    };
  },
  mounted () {
    this.getInfoReminder();
  },
  methods: {
    getInfoReminder () {
      const url = `rounds/${this.round.id}/emails/send-reminders`;
      window.axios.get(url).then(response => {
        this.totalSend = response.data.total_send;
        this.totalNotSend = response.data.total_not_send;
      }).catch(error => {
        console.log(error);
      });
    },
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/client/rounds/modals/sendReminderConfirm.vue